import React from 'react';
import config from '../config';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import { useTheme } from '../context/ThemeContext';
import LinkedInIcon from '../assets/icons/linkedin.png';
import GithubIcon from '../assets/icons/github.png';
import FacebookIcon from '../assets/icons/facebook.png';
import InstagramIcon from '../assets/icons/instagram.png';
import { FaEnvelope, FaMapMarkerAlt, FaHome, FaUser, FaFileAlt, FaCode, FaPaperPlane, FaGamepad, FaPen } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const FooterStyle = styled.div`
  background-color: var(--deep-dark);
    padding: 8rem 0 1rem;
    color: var(--gray-1);

  .container {
    display: flex;
    gap: 3rem;
  }
  
  .footer__col1 {
    flex: 2;
    display: flex;
    flex-direction: column;
  }
  .footer__col1__theme {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: auto;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    gap: 1.2rem;
  }
  .footer__dino-link {
    display: inline-flex;
    align-items: center;
    margin-left: 10px;
    color: var(--highlight-blue);
    opacity: 0.35;
    font-size: 4rem;
    transition: opacity 0.2s ease, transform 0.2s ease;
    &:hover {
      opacity: 1;
      transform: scale(1.2);
    }
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  const { theme, setTheme, themes } = useTheme();

  let newDate = new Date()
  let currentYear = newDate.getFullYear();

  return (
    <FooterStyle className="site-footer">
      <div className="container">
        <div className="footer__col1">
          <h1 className="footer__col1__title">
            Anas Qazi
            <Link to="/games" className="footer__dino-link" aria-label="Mini Arcade" title="Mini Arcade Games">
              <FaGamepad />
            </Link>
          </h1>
          <div className="footer__col1__theme">
            <label
              htmlFor="theme-select"
              style={{
                fontFamily: 'RobotoMono Regular',
                fontSize: '1.4rem',
                color: 'var(--gray-1)',
                letterSpacing: '0.1rem',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
              }}
            >
              Theme
            </label>
            <select
              id="theme-select"
              value={theme}
              onChange={(e) => setTheme(e.target.value)}
              aria-label="Select theme"
              style={{
                background: 'var(--gray-2)',
                color: 'var(--gray-1)',
                border: '1px solid var(--gray-1)',
                borderRadius: '6px',
                padding: '0.5rem 1rem',
                fontFamily: 'RobotoMono Regular',
                fontSize: '1.4rem',
                cursor: 'pointer',
                outline: 'none',
              }}
            >
              {Object.entries(themes).map(([key, val]) => (
                <option key={key} value={key} style={{ background: 'var(--gray-2)', color: 'var(--gray-1)' }}>
                  {val.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Site Map"
            links={[
              { type: 'Link', title: 'Home',     path: '/',         faIcon: <FaHome /> },
              { type: 'Link', title: 'About',    path: '/about',    faIcon: <FaUser /> },
              { type: 'Link', title: 'Resume',   path: '/resume',   faIcon: <FaFileAlt /> },
              ...(config.projectsSectionEnabled ? [{ type: 'Link', title: 'Projects', path: '/projects', faIcon: <FaCode /> }] : []),
              ...(config.blogEnabled ? [{ type: 'Link', title: 'Blog', path: '/blog', faIcon: <FaPen /> }] : []),
              { type: 'Link', title: 'Contact',  path: '/contact',  faIcon: <FaPaperPlane /> },
              // { type: 'Link', title: 'Games',    path: '/games',    faIcon: <FaGamepad /> },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Get in Touch"
            links={[
              {
                title: 'ianasqazi@gmail.com',
                path: 'mailto:ianasqazi@gmail.com',
                faIcon: <FaEnvelope />,
              },
              {
                title: 'Toronto, Canada',
                path: 'https://www.google.com/maps/place/Toronto,+ON/@43.717899,-79.6582408,10z/data=!3m1!4b1!4m5!3m4!1s0x89d4cb90d7c63ba5:0x323555502ab4c477!8m2!3d43.653226!4d-79.3831843?hl=en-GB',
                target: '_blank',
                faIcon: <FaMapMarkerAlt />,
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="Connect"
            links={[
              {
                title: 'LinkedIn',
                target: "_blank",
                path: 'https://www.linkedin.com/in/anasqazi/',
                icon: LinkedInIcon,
              },
              {
                title: 'Github',
                target: "_blank",
                path: 'https://www.github.com/ianasqazi/',
                icon: GithubIcon,
              },
              {
                title: 'Facebook',
                target: "_blank",
                path: 'https://www.facebook.com/ianasqazi',
                icon: FacebookIcon,
              },
              {
                title: 'Instagram',
                target: "_blank",
                path: 'https://www.instagram.com/ianasqazi',
                icon: InstagramIcon,
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div style={{ textAlign: 'right', paddingRight:'40px' }}>
          <span id="footerNoteSpan"> &copy; Anas Qazi - {currentYear}</span>
        </div>
      </div>
    </FooterStyle>
  );
}
